import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {FormattedMessage} from "react-intl";

interface CreateReleaseDateProps {
  createdAt?: string;
  releaseDate?: string;
}

export const CreateReleaseDate: React.FC<CreateReleaseDateProps> = props => {
  const { createdAt, releaseDate } = props;
  return (
    <Container>
      <Row>
        <FormattedMessage
          id="Releases.CreateReleaseDate.CreateDate"
          defaultMessage="Create date"
        />:<Value>{createdAt ? moment(createdAt).format('DD.MM.YYYY') : '-'}</Value>
      </Row>
      <Row>
        <FormattedMessage
          id="Releases.CreateReleaseDate.ReleaseDate"
          defaultMessage="Release date"
        />:<Value>{releaseDate ? moment(releaseDate).format('DD.MM.YYYY') : '-'}</Value></Row>
    </Container>
  )
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Value = styled.div`
  font-weight: 600;
`;
